export default "__VITE_ASSET__BRjb$QS8__"